import React, {Component} from 'react';
import classNames from 'classnames';

class FileInputButton extends Component {
  get files() {
    return this.refs.input.files;
  }

  get form() {
    return this.refs.form;
  }

  clear() {
    this.refs.input.value = '';
  }

  className() {
    return classNames('ds-btn _file', this.props.className);
  }

  render() {
    const {buttonText, dataTestId, ...restOfProps} = this.props;

    return (
      <div className={this.className()}>
        {this.props.icon && <i className="materialIcon">{this.props.icon}</i>}
        <form ref="form" encType="multipart/form-data">
          <label htmlFor={this.props.name}> {this.props.buttonText}</label>
          <input
            data-testid={dataTestId}
            onClick={this.props.onClick}
            id={this.props.name}
            ref="input"
            type="file"
            {...restOfProps}
          />
        </form>
      </div>
    );
  }
}

FileInputButton.defaultProps = {
  onClick: () => {},
  multiple: false,
  name: 'file_input_button',
  accept: 'image/*,application/pdf',
  buttonText: 'Upload file',
};

export default FileInputButton;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/FileInputButton.js